export const momsregistrert = {
  utenMoms: "utenMoms",
  medMoms: "medMoms",
} as const
